"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PurePasswordResetSuccess = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _PasswordResetStyled = require("../PasswordReset/PasswordResetStyled");
var _Button = _interopRequireDefault(require("../Button"));
var _PasswordResetSuccessStyled = require("./PasswordResetSuccessStyled");
var _jsxRuntime = require("react/jsx-runtime");
const PasswordResetSuccess = _ref => {
  let {
    email,
    resetPasswordCallback
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PasswordResetStyled.PasswordResetWrapperStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PasswordResetSuccessStyled.PasswordResetSuccessPageStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetSuccessStyled.Loader, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetSuccessStyled.Checkmark, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetSuccessStyled.StyledTitle, {
        children: t('Password link sent')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordResetSuccessStyled.StyledMessage, {
        children: email ? t('Please check your inbox at {{email}}', {
          email
        }) : t('Please check your inbox')
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PasswordResetSuccessStyled.NoteStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "link",
          onClickFn: resetPasswordCallback,
          children: t('Go back to the login page')
        }), "\xA0"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
  });
};
exports.PurePasswordResetSuccess = PasswordResetSuccess;
PasswordResetSuccess.propTypes = {
  email: _propTypes.default.string.isRequired,
  resetPasswordCallback: _propTypes.default.func
};
PasswordResetSuccess.defaultProps = {
  resetPasswordCallback: () => null
};
var _default = exports.default = PasswordResetSuccess;